// extracted by mini-css-extract-plugin
export default {"header":"NavHeader_header__I+BZx","logo":"NavHeader_logo__lPOb5"};